export const BrokerManagementbreadCrumbsData = {
 brokerManagement:[
    { title: 'Source Documents', to: '/sourcedocs/brokerManagement' },
    { title: 'Broker Management' }
  ],
  uploadBrokerManagement: [
    { title: "Source Documents", to: "/sourcedocs/brokerManagement" },
    { title: "Broker Management", to: "/sourcedocs/brokerManagement" },
    { title: "Upload" },
  ],
  uploadBrokerManagementFirstLook: [
    { title: "Source Documents", to: "/sourcedocs/brokerManagement" },
    { title: "Broker Management", to: "/sourcedocs/brokerManagement" },
    { title: "Upload First Look" },
  ],
  uploadBrokerManagementHotSheet: [
    { title: "Source Documents", to: "/sourcedocs/brokerManagement" },
    { title: "Broker Management", to: "/sourcedocs/brokerManagement" },
    { title: "Upload Hot Sheet" },
  ],
  createBrokerManagement: [
    { title: "Source Documents", to: "/sourcedocs/brokerManagement" },
    { title: "Broker Management", to: "/sourcedocs/brokerManagement" },
    { title: "New" },
  ],
    editBrokerManagement: [
    { title: "Source Documents", to: "/sourcedocs/brokerManagement" },
    { title: "Broker Management", to: "/sourcedocs/brokerManagement" },
    { title: "Edit" },
  ],
     cloneBrokerManagement: [
    { title: "Source Documents", to: "/sourcedocs/brokerManagement" },
    { title: "Broker Management", to: "/sourcedocs/brokerManagement" },
    { title: "Clone" },
  ],
}

